export default __webpack_public_path__ + "maps-examples-switch-styles-thumbnail-960-b11f1b93e7dfeaa7aa0c33c5bc339c5a.png";